<template>
  <div class="form__buttons">
    <AppButton
      :loading="isSending"
      :title="btnSubmitText"
      type="main"
      :disabled="isDisabled"
    />

    <AppButton
      title="Отмена"
      type="alt"
      @click.native.prevent="$emit('cancel')"
    />
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'

export default {
  name: 'FormButtonGroup',
  components: {
    AppButton
  },
  props: {
    isSending: {
      type: Boolean,
      required: false,
      default: false
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnSubmitText () {
      return this.isEdit ? 'Сохранить' : 'Создать'
    }
  }
}
</script>
